'use strict';

/* Views */
import Profile from './profile/profile.component';
import ProfilePictureUpload from './profile-picture-upload/profile-picture-upload.component';
import QuickbooksListComponent from './quickbooks-list/quickbooks-list.component';

export default angular.module('conduuApp.userProfile', [Profile, ProfilePictureUpload, QuickbooksListComponent])
  .name;



// WEBPACK FOOTER //
// ./client/app/user/index.js